import React from 'react';
import { Switch, Route, withRouter, Prompt } from 'react-router-dom';

import http from 'api/http';
import { boatAPI, inspectionAPI, trailerAPI, manufacturerAPI } from 'api/requests';

import List from './List';
import Details from './Details';
import New from './New';
import { ACTION, INSPECTION_STATUS, STATUS } from 'constants/index';
import { buttonColor, buttonType } from 'Components/Button';
import Modal from 'Components/Modal';
import NotificationManager from 'dom-managers/notification';
import Button from 'Components/Button';
import Store from '../../../registerIDBWorker';
import { ROLES } from 'constants/roles';
import Edit from './Edit';

const readableStatuses = [
  {name: 'All', value: 'All'},
  {name: 'Inspection Pending', value: INSPECTION_STATUS.REPORT_PENDING},
  {name: 'Inspection Incomplete', value: INSPECTION_STATUS.REPORT_INCOMPLETE},
  {name: 'Variation Pending', value: INSPECTION_STATUS.RESPONSE_PENDING},
  {name: 'Variation Incomplete', value: INSPECTION_STATUS.RESPONSE_INCOMPLETE},
  {name: 'Complete', value: INSPECTION_STATUS.COMPLETE}
];

@withRouter
export default class Inspection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inspectionList: [],
      currentModelYear: '',
      isModalOpen: false,
      requestInProcess: false,
      listRequestInProcess: true,
      manufacturerAddresses: [],
    };

    this.$modalBody = '';
    this.$modalAction = () => {};
    this.$hasUnsavedData = false;

    this.statuses = [
      {name: 'All', value: 'All'},
      {name: 'Inspection Pending', value: INSPECTION_STATUS.REPORT_PENDING},
      {name: 'Inspection Incomplete', value: INSPECTION_STATUS.REPORT_INCOMPLETE},
      {name: 'Variation Pending', value: INSPECTION_STATUS.RESPONSE_PENDING},
      {name: 'Variation Incomplete', value: INSPECTION_STATUS.RESPONSE_INCOMPLETE},
      {name: 'Complete', value: INSPECTION_STATUS.COMPLETE}
    ];

    if (props.user.isInspector()) {
      this.statuses.splice(3, 2);
    }

    if (!props.user.isInspector() && !props.user.isInternal()) {
      this.statuses.splice(1, 2);
    }
  }

  roleSwitch = () => {
    const {user, match} = this.props;

    let URLRole = '';

    Object.keys(ROLES).forEach(roleKey => {
      if (match.params.manufacturerRole === ROLES[roleKey].nameForUrl) URLRole = ROLES[roleKey];
    });

    if (URLRole && user.getActiveRole() !== URLRole.serverName) {
      user.changeMenu(URLRole.serverName);
    }
  };

  componentDidMount() {
    const {user} = this.props;

    this.roleSwitch();

    const $$getMethod = () => {
      if (user.getActiveRole() === ROLES.BOAT_MANUFACTURER.serverName) {
        return boatAPI.currentModelYear;
      }

      if (user.getActiveRole() === ROLES.TRAILER_MANUFACTURER.serverName) {
        return trailerAPI.currentModelYear;
      }
    };

    http.get($$getMethod())
      .then(({data}) => {
        this.setState({currentModelYear: data[0] ? (data[1] || data[0]) : data});
      });

    http.get(manufacturerAPI.addressesList(this.props.user.getManufacturerCode()))
      .then(({data}) => {
        let manufacturerAddresses = data.map(addressObject => {
          return ({
            name: [
              addressObject.Address1,
              addressObject.Address2,
              addressObject.Address3,
              addressObject.Address4,
              addressObject.City,
              addressObject.State,
              addressObject.PostalCode,
              addressObject.Country,
            ].filter(object => object).join(', '),
            value: {
              'mnfCity': addressObject.City,
              'mnfAddress': [
                addressObject.Address1,
                addressObject.Address2,
                addressObject.Address3,
                addressObject.Address4,
              ].filter(object => object).join(', '),
              'mnfCountry': addressObject.Country,
              'mnfCountryId': addressObject.CountryId,
              'mnfPostalCode': addressObject.PostalCode,
              'mnfState': addressObject.State,
            }
          });
        });
        this.setState({manufacturerAddresses})
      });

    this._loadFromStore();

    http.get(inspectionAPI.inspectionList(user.getActiveRole() === ROLES.BOAT_MANUFACTURER.serverName))
      .then(({data: inspectionList}) => {
        Store.insert(`INSPEC_${user.getActiveRole()}_LISTS`, inspectionList, user.getManufacturerCode())
          .then(() => {
            this._loadFromStore(() => {
              this.setState({listRequestInProcess: false});
            });
          });
      });
  }

  _loadFromStore = (cb = () => {}) => {
    const {user} = this.props;

    Store.select(`INSPEC_${user.getActiveRole()}_LISTS`, user.getManufacturerCode())
      .then(inspectionList => {
        this.setState({inspectionList}, cb);
      });
  };

  _updateEntry = entry => {
    const {inspectionList} = this.state;
    const {user} = this.props;

    let inspectionIndex = -1;

    if (entry.response !== undefined) {
      inspectionIndex = inspectionList.findIndex(inspect => +inspect.id === +entry.id);

      if (inspectionIndex !== -1) {
        inspectionList[inspectionIndex] = entry;
      } else {
        inspectionList.push(entry);
        inspectionIndex = inspectionList.length - 1;
      }
    } else {
      inspectionIndex = inspectionList.findIndex(inspect => {
        if (inspect.response) {
          return +inspect.response.id === +entry.id;
        }

        return false;
      });

      if (inspectionIndex !== -1) {
        inspectionList[inspectionIndex].response = entry;
      }
    }

    this.setState({inspectionList}, () => {
      Store.insert(`INSPEC_${user.getActiveRole()}_LISTS`, inspectionList[inspectionIndex], user.getManufacturerCode());
    });
  };

  _deleteEntry = id => {
    const {inspectionList} = this.state;
    const {user} = this.props;

    const inspectionIndex = inspectionList.findIndex(inspect => +inspect.id === +id);

    if (inspectionIndex) {
      Store.delete(`INSPEC_${user.getActiveRole()}_LISTS`, inspectionList[inspectionIndex])
        .then(() => {
          inspectionList.splice(inspectionIndex, 1);

          this.setState({inspectionList});
        });
    }
  };

  markStepAsRedacted = () => {
    this.$hasUnsavedData = true;
  };

  createActionList = inspection => {
    const {user} = this.props;
    const list = [ACTION.DETAILS];

    if (user.isInspector()) {
      if (inspection.status !== STATUS.COMPLETE) {
        list.push(ACTION.EDIT);
      }
      if (inspection.status === STATUS.INCOMPLETE) {
        list.push(ACTION.RESUBMIT);
      }
    }

    if (!user.isInternal() && !user.isInspector()) {
      if (inspection.response && inspection.response.status === STATUS.INCOMPLETE) {
        list.push(ACTION.EDIT);
        list.push(ACTION.SUBMIT_RESPONSE);
      }
    }

    if (user.isInternal()) {
      list.push(ACTION.EDIT);

      switch (inspection.status) {
        case STATUS.PENDING:
          list.push(ACTION.INCOMPLETE_REPORT);

          list.push(ACTION.APPROVE_WITHOUT_RESPONSE);
          list.push(ACTION.APPROVE_WITH_RESPONSE);

          list.push(ACTION.E_SIGN_REPORT);

          list.push(ACTION.DELETE);
          break;
        case STATUS.INCOMPLETE:
          list.push(ACTION.RESUBMIT);
          list.push(ACTION.DELETE);
          break;
        case STATUS.COMPLETE:
          list.push(ACTION.INCOMPLETE_REPORT);

          if (inspection.vresponseRequired && (!inspection.response || inspection.response.status !== STATUS.COMPLETE)) {
            list.push(ACTION.DELETE_RESPONSE);
          } else if (!inspection.vresponseRequired) {
            list.push(ACTION.NEED_RESPONSE);
          }

          if (inspection.response) {
            switch (inspection.response.status) {
              case STATUS.INCOMPLETE:
                list.push(ACTION.SUBMIT_RESPONSE);
                break;
              case STATUS.PENDING:
                list.push(ACTION.INCOMPLETE_RESPONSE);
                list.push(ACTION.APPROVE_RESPONSE);
                break;
              case STATUS.COMPLETE:
                list.push(ACTION.INCOMPLETE_RESPONSE);
                break;
            }
          }

          break;
      }
    }

    return list;
  };

  performAction = (action, id, cb = () => {}) => () => {
    const {user} = this.props;

    switch (action) {
      case ACTION.DETAILS:
        return user.goToInspectionDetails(id);
      case ACTION.EDIT:
        return user.goToInspectionEdit(id);
      case ACTION.APPROVE_WITHOUT_RESPONSE:
        return this._handleApproveReport(id, false, cb);
      case ACTION.APPROVE_WITH_RESPONSE:
        return this._handleApproveReport(id, true, cb);
      case ACTION.INCOMPLETE_REPORT:
        return this._handleIncompleteReport(id, cb);
      case ACTION.RESUBMIT:
        return this._handleResubmitReport(id, cb);
      case ACTION.NEED_RESPONSE:
        return this._handleRequestResponse(id, true, cb);
      case ACTION.DELETE_RESPONSE:
        return this._handleRequestResponse(id, false, cb);
      case ACTION.DELETE:
        return this._handleDeleteReport(id, cb);
      case ACTION.INCOMPLETE_RESPONSE:
        return this._handleIncompleteResponse(id, cb);
      case ACTION.APPROVE_RESPONSE:
        return this._handleApproveResponse(id, cb);
      case ACTION.SUBMIT_RESPONSE:
        return this._handleSubmitResponse(id, cb);
      case ACTION.E_SIGN_REPORT:
        return this.handleESignReport(id, cb);
    }
  };

  _handleSubmitResponse = (id, cb) => {
    const $submit = () => {
      this.setState({requestInProcess: true}, () => {
        http.patch(inspectionAPI.submitVarianceResponse(id))
          .then(({data}) => {
            NotificationManager.success(1, 'Your Variation Response documentation has been submitted successfully.');
            this._updateEntry(data);
            cb(data);
          })
          .finally(() => {
            this._closeModal();
          });
      });
    };

    this.$modalBody = 'Are you sure you want to submit Variation Response documentation to NMMA?';
    this.$modalAction = $submit;
    this._openModal();
  };

  _handleApproveReport = (id, needResponse, cb) => {
    const $approve = () => {
      this.setState({requestInProcess: true}, () => {
        http.patch(inspectionAPI.approveReport(id, needResponse))
          .then(({data}) => {
            this.$hasUnsavedData = false;
            if (needResponse) {
              NotificationManager.success(1, 'Your Variation Response request has been sent successfully.');
            } else {
              NotificationManager.success(1, 'Your Inspection Record Application has been approved successfully.');
            }
            this._updateEntry(data);
            cb(data);
          })
          .finally(() => {
            this._closeModal();
          });
      });
    };

    if (needResponse) {
      this.$modalBody = 'Are you sure you want to approve this Inspection report and request a Variation response from the manufacturer?';
    } else {
      this.$modalBody = 'Are you sure you want to approve this Inspection report without requesting a Variation response from the manufacturer?';
    }

    this.$modalAction = $approve;
    this._openModal();
  };

  _handleIncompleteReport = (id, cb) => {
    const $incomplete = () => {
      this.setState({requestInProcess: true}, () => {
        http.patch(inspectionAPI.incompleteReport(id))
          .then(({data}) => {
            this.$hasUnsavedData = false;
            NotificationManager.success(1, 'Your Inspection Report has been marked as incomplete successfully.');
            this._updateEntry(data);
            cb(data);
          })
          .finally(() => {
            this._closeModal();
          });
      });
    };

    this.$modalBody = 'Are you sure you want to mark this Inspection Report as Incomplete?';
    this.$modalAction = $incomplete;
    this._openModal();
  };

  _handleIncompleteResponse = (id, cb) => {
    const $incomplete = () => {
      this.setState({requestInProcess: true}, () => {
        http.patch(inspectionAPI.incompleteResponse(id))
          .then(({data}) => {
            this.$hasUnsavedData = false;
            NotificationManager.success(1, 'Your Variation Response has been marked as incomplete successfully.');
            this._updateEntry(data);
            cb(data);
          })
          .finally(() => {
            this._closeModal();
          });
      });
    };

    this.$modalBody = 'Are you sure you want to mark this Variation Response as Incomplete?';
    this.$modalAction = $incomplete;
    this._openModal();
  };

  _handleApproveResponse = (id, cb) => {
    const $approve = () => {
      this.setState({requestInProcess: true}, () => {
        http.patch(inspectionAPI.approveResponse(id))
          .then(({data}) => {
            this.$hasUnsavedData = false;
            NotificationManager.success(1, 'Your Variation Response has been completed successfully.');
            this._updateEntry(data);
            cb(data);
          })
          .finally(() => {
            this._closeModal();
          });
      });
    };

    this.$modalBody = 'Are you sure you want to Approve this Variation Response?';
    this.$modalAction = $approve;
    this._openModal();
  };

  handleESignReport = (id) => {
    this.$modalBody = 'Are you sure you want to generate and e-sign the inspection report?';
    this.$modalAction = () => {
      this.setState({requestInProcess: true}, () => {
        http.post(inspectionAPI.eSignReport(id))
          .then(() => {
            NotificationManager.success(1, 'Inspection report has been successfully generated and sent for e-signature to DocuSign.');
          })
          .finally(() => {
            this._closeModal();
          });
      });
    };

    this._openModal();
  };

  handleUpdate = callback => {
    this.$modalBody = 'Are you sure you want to Update this Inspection Record application?';
    this.$modalAction = async () => {
      this.setState({requestInProcess: true}, async () => {
        const result = await callback();
        if (result.report !== null && result.response !== null) {
          this.$hasUnsavedData = false;
          NotificationManager.success(1, 'Your Inspection Record application has been updated successfully. Click Submit button to complete submission.');
          this._closeModal(undefined, this.handleGoBackClick);

          if (result.report) this._updateEntry(result.report);
          if (result.response) this._updateEntry(result.response);
        } else {
          this._closeModal();
        }
      });
    };
    this._openModal();
  };

  handleSaveAndSubmit = callback => {
    this.$modalBody =
      'You are about to save your changes and submit the application for processing. Are you sure you want to proceed?';
    this.$modalAction = async () => {
      this.setState({requestInProcess: true}, async () => {
        const result = await callback();
        if (result.report !== null && result.response !== null) {
          this.$hasUnsavedData = false;
          NotificationManager.success(1, 'Your Inspection Record application has been updated and submitted successfully.');
          this._closeModal(undefined, this.handleGoBackClick);

          if (result.report) this._updateEntry(result.report);
          if (result.response) this._updateEntry(result.response);
          if (result.entry.data )this._updateEntry(result.entry.data);

        } else {
          this._closeModal();
        }
      });
    };
    this._openModal();
  };

  handleSubmitReport = (inspectionId, requestJson, documents) => {
    const {user} = this.props;

    const $submit = () => {
      const data = new FormData();
      data.append('requestJson', JSON.stringify(requestJson));
      documents.filter(file => !file.created).forEach(file => {
        data.append('reports', file);
      });

      this.setState({requestInProcess: true}, () => {
        let request = {};

        if (isFinite(inspectionId)) {
          request.url = inspectionAPI.inspectionDetails(inspectionId);
          request.method = 'post';
        } else {
          request.url = inspectionAPI.submitInspectionRequest;
          request.method = 'post';
        }

        http[request.method](request.url, data)
          .then(({data}) => {
            this.$hasUnsavedData = false;
            NotificationManager.success(1, 'Your Inspection Report has been submitted successfully');
            this._updateEntry(data);

            this._closeModal(undefined, () => {
              user.saveSelectedYear(requestJson.year);
              this.handleGoBackClick({filter: {year: requestJson.year}});
            });
          })
          .finally(() => {
            this._closeModal();
          });
      });
    };

    this.$modalBody = 'Are you sure you want to submit the Inspection Report?';
    this.$modalAction = $submit;
    this._openModal();
  };

  handleSubmitResponse = (requestJson, documents) => {
    const $submit = () => {
      const data = new FormData();
      data.append('requestJson', JSON.stringify(requestJson));
      documents.filter(file => !file.created).forEach(file => {
        data.append('reports', file);
      });

      this.setState({requestInProcess: true}, () => {
        http.post(inspectionAPI.saveVarianceResponse, data)
          .then(({data}) => {
            this.$hasUnsavedData = false;
            NotificationManager.success(1, 'Your application has been submitted successfully');
            this._updateEntry(data);
            this._closeModal(undefined, this.handleGoBackClick);
          })
          .finally(() => {
            this._closeModal();
          });
      });
    };

    this.$modalBody = 'Are you sure you want to approve this Inspection report and request Variation response from the manufacturer?';
    this.$modalAction = $submit;
    this._openModal();
  };

  _handleRequestResponse = (id, isRequired, cb) => {
    const $requestResponse = () => {
      this.setState({requestInProcess: true}, () => {
        http.patch(inspectionAPI.requestResponse(id, isRequired))
          .then(({data}) => {
            this.$hasUnsavedData = false;

            if (isRequired) {
              NotificationManager.success(1, 'Your Variation Response request has been sent successfully.');
            } else {
              NotificationManager.success(1, 'Your Variation Response request has been canceled successfully.');
            }

            this._updateEntry(data);
            cb(data);
          })
          .finally(() => {
            this._closeModal();
          });
      });
    };

    if (isRequired) {
      this.$modalBody = 'Are you sure you want to Submit Variation Response request?';
    } else {
      this.$modalBody = 'Are you sure you want to cancel Variation Response request?';
    }

    this.$modalAction = $requestResponse;
    this._openModal();
  };

  _handleResubmitReport = (id, cb) => {
    const $resubmit = () => {
      this.setState({requestInProcess: true}, () => {
        http.patch(inspectionAPI.resubmitReport(id))
          .then(({data}) => {
            this.$hasUnsavedData = false;
            NotificationManager.success(1, 'Your Inspection Report has been resubmitted successfully.');
            this._updateEntry(data);
            cb(data);
          })
          .finally(() => {
            this._closeModal();
          });
      });
    };

    this.$modalBody = 'Are you sure you want to Resubmit the Inspection Report?';
    this.$modalAction = $resubmit;
    this._openModal();
  };

  _handleDeleteReport = id => {
    const {location} = this.props;

    const $delete = () => {
      this.setState({requestInProcess: true}, () => {
        http.delete(inspectionAPI.deleteReport(id))
          .then(() => {
            this.$hasUnsavedData = false;
            NotificationManager.success(1, 'Your Inspection Record application has been deleted successfully');
            this._closeModal(undefined, () => {
              if (location.pathname.includes('/details')) {
                this.handleGoBackClick();
              }
            });
            this._deleteEntry(id);
          })
          .finally(() => {
            this._closeModal();
          });
      });
    };

    this.$modalBody = 'Are you sure you want to delete this Inspection Record application?';
    this.$modalAction = $delete;
    this._openModal();
  };

  getReadableStatus = (inspection, value) => {
    let resultStatus = null;

    const $getResponseStatus = () => {
      if (inspection.response.status === STATUS.COMPLETE) {
        return readableStatuses[readableStatuses.length - 1];
      } else {
        return readableStatuses.find(status => status.value === `RESPONSE_${inspection.response.status}`);
      }
    };

    const $getReportStatus = () => {
      if (inspection.status === STATUS.COMPLETE) {
        return readableStatuses[readableStatuses.length - 1];
      } else {
        return readableStatuses.find(status => status.value === `REPORT_${inspection.status}`);
      }
    };

    if (inspection.status === STATUS.COMPLETE) {
      if (inspection.vresponseRequired && inspection.status !== STATUS.INCOMPLETE) {
        if (inspection.response) {
          resultStatus = $getResponseStatus();
        } else {
          resultStatus = $getReportStatus();
        }
      }
    }

    if (!resultStatus) {
      resultStatus = $getReportStatus();
    }

    if (resultStatus) {
      if (!value) {
        return resultStatus.name;
      } else {
        return resultStatus.value;
      }
    }

    return '';
  };

  handleGoBackClick = (params = false) => {
    const {user} = this.props;

    if (params.nativeEvent) params = false;

    user.goToInspectionList(params);
  };

  _blockUnconfirmedTransition = ({pathname}) => {
    const {user} = this.props;

    if (this.$hasUnsavedData) {
      this.$modalBody = 'You have unsaved data. Are you sure you want to exit Inspection Record Application without saving?';
      this.$modalAction = () => {
        this.$hasUnsavedData = false;
        this._closeModal(undefined, user.goTo(pathname));
      };

      this._openModal();

      return false;
    }

    return true;
  };

  _openModal = () => {
    this.setState({isModalOpen: true});
  };

  _closeModal = (event, cb = () => {}) => {
    this.setState({isModalOpen: false, requestInProcess: false}, cb);
  };

  getDetailsLink = model => {
    const {user} = this.props;

    let role = '';
    let detailsString = '';

    if (model.boatType) {
      role = ROLES.BOAT_MANUFACTURER.nameForUrl;
      detailsString = 'application/';
    } else {
      role = ROLES.TRAILER_MANUFACTURER.nameForUrl;
      detailsString = '#edit=';
    }

    return `/${user.getManufacturerCode()}/${role}/${detailsString}${model.id}`;
  };

  render() {
    const {isModalOpen, requestInProcess, manufacturerAddresses} = this.state;
    const {user, match} = this.props;

    return (
      <React.Fragment>
        <Switch>
          <Route
            exact
            path={match.url}
            render={() => (
              <List
                user={user}
                {...this.state}
                createActionList={this.createActionList}
                getReadableStatus={this.getReadableStatus}
                statuses={this.statuses}
                performAction={this.performAction}
              />
            )}
          />
          <Route
            exact
            path={`${match.url}/new`}
            render={() => (
              <New
                user={user}
                getDetailsLink={this.getDetailsLink}
                handleSubmitReport={this.handleSubmitReport}
                markStepAsRedacted={this.markStepAsRedacted}
                handleGoBackClick={this.handleGoBackClick}
                getReadableStatus={this.getReadableStatus}
                manufacturerAddresses={manufacturerAddresses}
              />
            )}
          />
          <Route
            path={`${match.url}/:inspectionId/details`}
            render={() => (
              <Details
                user={user}
                getDetailsLink={this.getDetailsLink}
                handleSubmitReport={this.handleSubmitReport}
                handleSubmitResponse={this.handleSubmitResponse}
                markStepAsRedacted={this.markStepAsRedacted}
                createActionList={this.createActionList}
                performAction={this.performAction}
                handleGoBackClick={this.handleGoBackClick}
                getReadableStatus={this.getReadableStatus}
                manufacturerAddresses={manufacturerAddresses}
              />
            )}
          />
          <Route
            path={`${match.url}/:inspectionId/edit`}
            render={() => (
              <Edit
                user={user}
                getDetailsLink={this.getDetailsLink}
                handleUpdate={this.handleUpdate}
                handleSaveAndSubmit={this.handleSaveAndSubmit}
                markStepAsRedacted={this.markStepAsRedacted}
                handleGoBackClick={this.handleGoBackClick}
                getReadableStatus={this.getReadableStatus}
                manufacturerAddresses={manufacturerAddresses}
              />
            )}
          />
        </Switch>

        <Modal isOpen={isModalOpen}>
          <header className='ect-modal-header'>Confirmation</header>
          <div className='ect-modal-body'>{this.$modalBody}</div>
          <footer className='ect-modal-footer'>
            <Button
              label='No'
              type={buttonType.secondary}
              color={buttonColor.gray}
              buttonClassName='_height_40 _width_160'
              onClick={this._closeModal}
            />
            <Button
              label='Yes'
              disabledWithSpinner={requestInProcess}
              buttonClassName='_height_40 _width_160'
              onClick={this.$modalAction}
            />
          </footer>
        </Modal>
        <Prompt message={this._blockUnconfirmedTransition} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/index.jsx